<template>
  <div class="market-vc-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch">
    </Search>
    <div class="fun-btn-box">
      <el-button type="primary" class="mr10" @click="onAdd">+ 创建储值卡</el-button>
      <selectCard></selectCard>
    </div>
    <Table
      ref="table"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #id="{ row }">{{ row.id }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #settlementType="{ row }">{{ settlementTypeMap[row.settlementType] || '---' }}</template>
      <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
      <template #amount="{ row }">{{ row.amount }}</template>
      <template #giveType="{ row }">{{ row.giveType || '---'}}</template>
      <!-- <template #price="{ row }">{{ row.price }}</template> -->
      <template #costRate="{ row }">{{ row.costRate }}%</template>
      <template #quantityLimit="{ row }">{{ row.quantityLimit }}</template>
      <template #remainingQuantity="{ row }">{{ row.remainingQuantity }}</template>
      <template #effectiveStr="{ row }">{{ row.effectiveStr || '---' }}</template>
      <template #effective="{ row }">
        <div>
          <span :class="`dot color${row.effective}`"></span>
          <span>{{ effectiveMap[row.effective] }}</span>
        </div>
      </template>
      <template #source="{ row }">{{ row.source }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="onDetail(scope.row)">查看详情</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableList from '@/mixins/tableList'
import { api_getValueCardList} from '@/api/market'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import SelectCard from "./components/selectCard";

export default {
  name: "mvcIndex",
  mixins: [ tableList ],
  components: {
    Search,
    Table,
    SelectCard,
  },
  data() {
    return {
      renderData: [
        {
          label: "储值卡名称",
          placeholder: "请输入储值卡名称",
          type: "input",
          key: "name",
        },
        {
          label: "创建时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "time",
          valueFormat: 'timestamp'
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          option: [
            {label: '启用', value: '1'},
            {label: '禁用', value: '0'},
            {label: '已售罄', value: '2'},
          ],
          key: "effective",
        },
      ],
      form: {},
      tableKey: false,
      tableThData: [
        { prop: "id", label: "储值卡ID", minWidth: "100", },
        { prop: "name", label: "储值卡名称", minWidth: "180", },
        { prop: "settlementType", label: "结算类型", minWidth: "120", },
        { prop: "useRangeType", label: "使用范围", minWidth: "120", },
        { prop: "giveType", label: "赠礼类型", minWidth: "120", },
        { prop: "amount", label: "面值(元)", minWidth: "100", },
        // { prop: "price", label: "售价(元)", minWidth: "100", },
        { prop: "costRate", label: "储值卡服务费", minWidth: "120", },
        { prop: "quantityLimit", label: "总数量（张）", minWidth: "120", },
        { prop: "remainingQuantity", label: "剩余数量（张）", minWidth: "120", },
        { prop: "effectiveStr", label: "卡有效时间", minWidth: "200", },
        { prop: "effective", label: "状态", minWidth: "120", },
        { prop: "source", label: "数据来源", minWidth: "100", },
        { prop: "operatorName", label: "操作人", minWidth: "100", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        {prop: "operation", label: "操作", minWidth: "180",},
      ],
      effectiveMap: {
        '0': '禁用',
        '1': '启用',
        '2': '已售罄',
      },
      exportLoading:false,
      selectedIds:[],
      selectedData:[],
      settlementTypeMap: {
        'Settlement': '门店结算',
        'ReduceIncome': '门店减收',
      },
    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      let params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.createdFrom = this.form.time ? this.form.time[0] : ''
      params.createdTo = this.form.time ? this.form.time[1] : ''
      delete params.time
      const data = await api_getValueCardList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 创建
    onAdd() {
      this.$router.push("/market/valueCard/add");
    },
    // 查看详情
    onDetail(row) {
      this.$router.push(`/market/valueCard/detail?id=${row.id}`);
    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-vc-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
  }

  .look-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    margin-right: 10px;

    &.color0 {
      background-color: #F74A4A;
    }
    &.color1 {
      background-color: #05c8af;
    }
    &.color2 {
      background-color: #ccc;
    }
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
